import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { visuallyHidden } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';
import { Text } from '$shared/components/Text';

export const StyledConditionallyHidden = styled.div<{ isHidden: boolean }>(
    ifProp('isHidden', () => ({
        ...visuallyHidden,
    }))
);

export const StyledNoResults = styled.div(({ theme }) => ({
    maxWidth: `${theme.sizes.noResultsMaxWidth}px`,
    margin: `${theme.spaces[4]} auto`,
    padding: `0 ${theme.spaces[3]}`,
    [breakpoints.md]: {
        padding: 0,
        margin: `${theme.spaces[7]} auto`,
    },
}));

export const StyledNotFoundText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spaces[2],
}));

export const StyledSearchQuery = styled.span(({ theme }) => ({
    color: theme.colors.dark50,
}));

export const StyledOverlineText = styled(Text)(({ theme }) => ({
    marginTop: theme.spaces[7],
    marginBottom: theme.spaces[3],
}));

export const StyledCategoriesWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spaces[2],
}));
